
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqlR_VreSWcm7NIkxlO_nneryMHiPeBvY_n1iy5QACO2gMeta } from "/codebuild/output/src4161274908/src/src/pages/faq.vue?macro=true";
import { default as menulrs96_45yToIXGauHGosItOtS41eCESgaUW_WLlv5ag_4Meta } from "/codebuild/output/src4161274908/src/src/pages/menu.vue?macro=true";
import { default as indexwgK3QqMSD_9oJubI8wJJl5bX3hDIeC1LN3GumdMl_45aUMeta } from "/codebuild/output/src4161274908/src/src/pages/index.vue?macro=true";
import { default as contactXOJKAI85iNWcr55_45K0tbWjcq3puBleowehutr4EaJr0Meta } from "/codebuild/output/src4161274908/src/src/pages/contact.vue?macro=true";
import { default as tutorialOkNHapVMl4q6M46_J1qhBXZ2zwuhK3Xy7DnhNBlYe_8Meta } from "/codebuild/output/src4161274908/src/src/pages/tutorial.vue?macro=true";
import { default as agreement2feh0SP_y8BS7hCkRM97VHBNlQVnmJd_z0w0mMhjPsEMeta } from "/codebuild/output/src4161274908/src/src/pages/agreement.vue?macro=true";
import { default as about_45passm6eD_45A7ui6r98_45eLpPe6MX8BgdCkWtb9Al0k2harKHQMeta } from "/codebuild/output/src4161274908/src/src/pages/about-pass.vue?macro=true";
import { default as indexxY4h25V7m3GDLmSEmS9sBJRINaQYdC_45jPYT85Bvpqo4Meta } from "/codebuild/output/src4161274908/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93JdNFoPWLG1T2d7jgEhAJpRZ_45VA64JzJ62LAFxk_45CGaQMeta } from "/codebuild/output/src4161274908/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceOoCfW7_ULN9rB0Sstyp6XY6iolqFWmsxQd0VciQzWbIMeta } from "/codebuild/output/src4161274908/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93aD14x_6snUW3y4ogCcLv0emgC6flFZaZyNknugifrx8Meta } from "/codebuild/output/src4161274908/src/src/pages/notice/[id].vue?macro=true";
import { default as indexl5UMOkxPN5DphMiq7G_F7dVlVVxbskC5915r0ypKrugMeta } from "/codebuild/output/src4161274908/src/src/pages/coupon/index.vue?macro=true";
import { default as indexGG5J5FazSPU9rbQUrddaOn1vrjzKuA4yZE_45H0wm1WxoMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/index.vue?macro=true";
import { default as index92p_UKxSKuLr_45hcZSWKVjPp7U_o8UPMwe4iVuLSWSucMeta } from "/codebuild/output/src4161274908/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_934xBDmtI5zSi3tCizJRFc8Bs0kcJeVW_45_45PD5ezYkHNQsMeta } from "/codebuild/output/src4161274908/src/src/pages/parking/[id].vue?macro=true";
import { default as indexT8xm6SssEVXpyUOhjB7iMI7URGxUj7YFJdKltaEjaQEMeta } from "/codebuild/output/src4161274908/src/src/pages/history/index.vue?macro=true";
import { default as index5n5FTMm9J2szIU6_45EUXzaHLU4xz81MUixsJwEUv4bigMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/index.vue?macro=true";
import { default as indexD5Ju0F2TIy_45koWeKnUfntNwrEs3iJX8_45QynEjixASWkMeta } from "/codebuild/output/src4161274908/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexnAJIbbCusjIcmFzv1MA830WQGThLAE9pRplFRXTOmpoMeta } from "/codebuild/output/src4161274908/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi3sP2lW5qlxNQEmlj77_z97MBdMzdcbhyqZY4VySV9qsMeta } from "/codebuild/output/src4161274908/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit_45J4w4JjmkCjTSguDu2YsyCD91chRofPG3l5El4f8tCMMeta } from "/codebuild/output/src4161274908/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementR6p2yXhOUcn8HOjQD_HOU8Y4hOdLSFscTThA5mQkV7MMeta } from "/codebuild/output/src4161274908/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexWfeTaVKXskAlf_45j3_45s3Ns3gbTwg0cIk0_45kJeh3RLbOgMeta } from "/codebuild/output/src4161274908/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dFhVKDmbUdqQWZz8dv50Jm1mMO7TM2_8ler1stLczL5AMeta } from "/codebuild/output/src4161274908/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmr_45j_6hy1UL3z75a7BZrVZ73fTAWluw8Ve8_45YP7xlfioMeta } from "/codebuild/output/src4161274908/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexO3VxpPDU57Kb_45pAURz1DHE6RmZlynZqFPUc_I1A2PHkMeta } from "/codebuild/output/src4161274908/src/src/pages/card/create/index.vue?macro=true";
import { default as index42gFXdnzvNEoDKfsDsgSK9_yz8gDui2qb_KyDGYJOaIMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmvKteH_6zrIJ3XUNHCkBD9lWoWpugd_45PuO_k09CuAYWwMeta } from "/codebuild/output/src4161274908/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmpUZ4IAkpUqsnAdGu5AE0OkiLktafo6Jpcvf2regv7PUMeta } from "/codebuild/output/src4161274908/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete7bsQ3535vXbdIaCPq9dkKkOuSGt7j__plDBRD7dIpoUMeta } from "/codebuild/output/src4161274908/src/src/pages/membership/complete.vue?macro=true";
import { default as register5C7h2wys5t2Z28EYCrTswa9MxbW_45zU5C7wKKoIOsM1QMeta } from "/codebuild/output/src4161274908/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93GWJPnb1TC8UnzZyDpYaU3Vnq4tTcPHTyTgkuKtQ1WHAMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmNrMyOLmhA_45NKhiB25DjZz_45DKS_QWrqKSnRUAWenTKzMMeta } from "/codebuild/output/src4161274908/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93NY9N0Ol8vFuDpvtZRblICIY9IXTKOKEOITOkHVxmwWQMeta } from "/codebuild/output/src4161274908/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexlGGA4CBaglBXfswgGvGQrs34buhKh_45t4pJPnRZymZyEMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code8LdFEKBEP_45SWqLbPcqUfFBxZezafljEJ9ajE101XmgAMeta } from "/codebuild/output/src4161274908/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code6z0nuJp_UhKhdc9hDAa_45GYcapgK6_jPTWKCwSxGTaPMMeta } from "/codebuild/output/src4161274908/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeGknBdpsaT83OCMEp3d3Pr6abVDSTARuI6hgN8uXclOQMeta } from "/codebuild/output/src4161274908/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registeranPTDIYXtaF2Pczv8cOD_i591Y9j271qvuad2oIrx98Meta } from "/codebuild/output/src4161274908/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeYjTK7GW9a7vhVKM_uG48joyhUEMKKmXiIk91Y2rSHC4Meta } from "/codebuild/output/src4161274908/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexARhXVZVT9c_Mmia5mTOusCw4q13wDzmIn4QqxCeMQuEMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmuawW7MPG_458_A58gR049R_45Cwv3u9DtrFWEhjKOcpueV8Meta } from "/codebuild/output/src4161274908/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeabqaa48coeM_e__jyMdkey4ZZXmNnqncDCVv5Ye181cMeta } from "/codebuild/output/src4161274908/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index0aXtPHlAlKm3_45Wg6LfsmSuVmKNRyOBs9E7trvmxOqdQMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Wd2qXLsUh2d_45MVZJvYgnrffqjQdI8nEQWej7I4jbtd4Meta } from "/codebuild/output/src4161274908/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete5J6Onb_jYE25CywbKYXPKeF6mmNYgn6SM5bq2TKWk_EMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasMCU8Jgr9rwAimp2B92dJXuHztzIbPJY3fCeSVu9XQLoMeta } from "/codebuild/output/src4161274908/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleuzqrC52JGPKNwX08pQDmjpC2n3kb_nWELYoRY18EFHMMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email26PjxGQ4SAqXD6aNepW4AoPKk_45EoLARnnflUEpki808Meta } from "/codebuild/output/src4161274908/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmSgFobz2HkBNM2DS5J7syxL7wBKfY4ECGB9QHL9geQGYMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentPvSI0TjjS8mzvFwV5MB6r9pww4BdJFn2ZgqbOHsjz1gMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmINyM1Fx42Y0pSbcZAAICqAqNMIxgwGJt58DcbSS027cMeta } from "/codebuild/output/src4161274908/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateiiD2ZH2rsGDU5quBKOLBahdTcTFq_qLrGco4oEYK_gIMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completejhB7ckIoxYf7_45oPewEEXlJCTKDo00AIECK7hjrdcoxIMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codervRXe55y_45fbtBhGLS_RvSeHtBEykmIJk0eE2Fl91qTAMeta } from "/codebuild/output/src4161274908/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passworddUCf32iGO3LpMB5TPlCZoRL8VxCb8bEi6kCwTn3MavkMeta } from "/codebuild/output/src4161274908/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias_5O4sIRdEauvLzAjmFXXa9ez_9CAOTQZjdXkPD50S70Meta } from "/codebuild/output/src4161274908/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registermKebXJVkFxgOvr04nqfVSPhTVeOuYyiaXJbc4iAC4o0Meta } from "/codebuild/output/src4161274908/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeAb_45SKXp8J1kJ3VfrKnESJn_yrEI5z0LCan6QxoWAfDoMeta } from "/codebuild/output/src4161274908/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexoTyT99XsiTvNgC_45J_6bbs1v7mH6GDvK4DBCTaZ9ddjkMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index6oqp3EWFIuk2TgYtbzlHMfnCQiNV_45le7XGKslPsDYYgMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index6V3eQeSPBKgVH4CUUIgkGMqVBJ61CQqUdHODbmzSFOsMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index3ucCBFORoB6M7nNhE0xAt4i2jqHqSHBX_n4DRr31eAQMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update1_45_2yIktlljFXqiuSQLZyVTPZjsPeZeNxAs1R_0fb30Meta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete9af703jv1atmqc8UhvAxY4DjngzNvb1KuDvGPBBCeRgMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm7I_453CqX_ArvemmQgJEo7Jc2RwPDpgCe0LuJaDeOFOJQMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexh0CuHNiGEwlPTSlXMHpvWXOCmP1lj_45y9HK2zF1Zzp2gMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeYWWK8ADMZK5xpglsySycUHzFCCbxGME_45TE9tev901NkMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateS0Di1dQ7e6GN2BrXVec4g2XtrcmmCm7jcQryt7AhlYEMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexyQmyxp1ypJMbLD31r95XeyOkfwk1Ezp20IhSTrybY9oMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexhxB7oN49I9Ma4GidYdAKmSs9TFrX9Bdo3fnfv7L7mEIMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeHsTtOkAHZ5ZKOXcBuqvb3vjFbIoioCZrs_458PPf8xE74Meta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexlD6SuAYt9SjKGPALtJzK28K7fmjeQw0zpxYlP9gNAc8Meta } from "/codebuild/output/src4161274908/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code0B2l64guqeZ4iX1jxhxo_sujDkmvQ6pXb2Gcbw7Qw3QMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexfsinSNjrK0GIz8dC85tloNV6H1ux9cSaHMTZx5kDICQMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexBT7IgO2XIgKZxTbIlOtjVOPxYCWuLdLvJhjhLrnGmFoMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index6s02zCZbLZYvUQ3RM4Vp7QMHYLEEOfMTrAix9jIDt8kMeta } from "/codebuild/output/src4161274908/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatevyXD3P2xTe8SKQfRQTUCeZSq0CUUnIeavFawCSPq9FMMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmsDN8hG_45tpufVp9eakvoZmEsVbZ1yDZFsrGYFcyiVM0MMeta } from "/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menulrs96_45yToIXGauHGosItOtS41eCESgaUW_WLlv5ag_4Meta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexwgK3QqMSD_9oJubI8wJJl5bX3hDIeC1LN3GumdMl_45aUMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexl5UMOkxPN5DphMiq7G_F7dVlVVxbskC5915r0ypKrugMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexT8xm6SssEVXpyUOhjB7iMI7URGxUj7YFJdKltaEjaQEMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexD5Ju0F2TIy_45koWeKnUfntNwrEs3iJX8_45QynEjixASWkMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexnAJIbbCusjIcmFzv1MA830WQGThLAE9pRplFRXTOmpoMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexO3VxpPDU57Kb_45pAURz1DHE6RmZlynZqFPUc_I1A2PHkMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmvKteH_6zrIJ3XUNHCkBD9lWoWpugd_45PuO_k09CuAYWwMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmpUZ4IAkpUqsnAdGu5AE0OkiLktafo6Jpcvf2regv7PUMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete7bsQ3535vXbdIaCPq9dkKkOuSGt7j__plDBRD7dIpoUMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register5C7h2wys5t2Z28EYCrTswa9MxbW_45zU5C7wKKoIOsM1QMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmNrMyOLmhA_45NKhiB25DjZz_45DKS_QWrqKSnRUAWenTKzMMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code8LdFEKBEP_45SWqLbPcqUfFBxZezafljEJ9ajE101XmgAMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code6z0nuJp_UhKhdc9hDAa_45GYcapgK6_jPTWKCwSxGTaPMMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeGknBdpsaT83OCMEp3d3Pr6abVDSTARuI6hgN8uXclOQMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registeranPTDIYXtaF2Pczv8cOD_i591Y9j271qvuad2oIrx98Meta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmuawW7MPG_458_A58gR049R_45Cwv3u9DtrFWEhjKOcpueV8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeabqaa48coeM_e__jyMdkey4ZZXmNnqncDCVv5Ye181cMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index0aXtPHlAlKm3_45Wg6LfsmSuVmKNRyOBs9E7trvmxOqdQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete5J6Onb_jYE25CywbKYXPKeF6mmNYgn6SM5bq2TKWk_EMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleuzqrC52JGPKNwX08pQDmjpC2n3kb_nWELYoRY18EFHMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email26PjxGQ4SAqXD6aNepW4AoPKk_45EoLARnnflUEpki808Meta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmSgFobz2HkBNM2DS5J7syxL7wBKfY4ECGB9QHL9geQGYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentPvSI0TjjS8mzvFwV5MB6r9pww4BdJFn2ZgqbOHsjz1gMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmINyM1Fx42Y0pSbcZAAICqAqNMIxgwGJt58DcbSS027cMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completejhB7ckIoxYf7_45oPewEEXlJCTKDo00AIECK7hjrdcoxIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codervRXe55y_45fbtBhGLS_RvSeHtBEykmIJk0eE2Fl91qTAMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passworddUCf32iGO3LpMB5TPlCZoRL8VxCb8bEi6kCwTn3MavkMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registermKebXJVkFxgOvr04nqfVSPhTVeOuYyiaXJbc4iAC4o0Meta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeAb_45SKXp8J1kJ3VfrKnESJn_yrEI5z0LCan6QxoWAfDoMeta || {},
    component: () => import("/codebuild/output/src4161274908/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4161274908/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]